import { useState } from "react";

interface ReviewCardProps {
  name: string;
  initial: string;
  rating: number;
  time: string;
  text: string;
  likes: number;
  replies: number;
}

const avatarStyles = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-900",
];

export default function ReviewCard({
  name,
  initial,
  rating,
  time,
  text,
  likes,
  replies,
}: ReviewCardProps) {
  const [liked, setLiked] = useState(false);
  const likeCount = liked ? likes + 1 : likes;
  const avatarStyle = avatarStyles[initial.charCodeAt(0) % avatarStyles.length];

  return (
    <article className="rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-6">
      <div className="flex items-start gap-4">
        <span
          className={`w-11 h-11 shrink-0 flex items-center justify-center rounded-full font-heading text-lg ${avatarStyle}`}
        >
          {initial}
        </span>
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-3">
            <span className="font-heading text-base text-foreground-950">{name}</span>
            <span className="flex items-center gap-0.5 text-accent-500">
              {Array.from({ length: 5 }).map((_, index) => (
                <i
                  key={index}
                  className={index < rating ? "ri-star-fill text-sm" : "ri-star-line text-sm"}
                />
              ))}
            </span>
            <span className="text-xs font-label text-foreground-400">{time}</span>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700">{text}</p>

          <div className="mt-4 flex items-center gap-6">
            <button
              type="button"
              onClick={() => setLiked((prev) => !prev)}
              className={`inline-flex items-center gap-1.5 text-sm font-label transition-colors cursor-pointer ${
                liked ? "text-primary-600" : "text-foreground-500 hover:text-primary-600"
              }`}
            >
              <i className={liked ? "ri-heart-3-fill" : "ri-heart-3-line"} />
              {likeCount}
            </button>
            <span className="inline-flex items-center gap-1.5 text-sm font-label text-foreground-500">
              <i className="ri-chat-3-line" />
              {replies}
            </span>
          </div>
        </div>
      </div>
    </article>
  );
}